export {
  lookup,
  createUUID,
  parseDateOrToday,
  listDaysFromDate,
  rangeRandom,
  numberToPrecisionFloat,
};

function lookup(obj, k) {
  if (typeof obj !== "object") {
    return null;
  }
  var result = null;
  if (obj.hasOwnProperty(k)) {
    return obj[k];
  } else {
    for (var o in obj) {
      result = lookup(obj[o], k);
      if (result == null) continue;
      else break;
    }
  }
  return result;
}

function createUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0;
    var v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function rangeRandom(min = 0, max = 100, returnFloat = false) {
  let num = Math.random() * (max - min + 1) + min;
  return returnFloat ? numberToPrecisionFloat(num, 2) : Math.floor(num);
}

function numberToPrecisionFloat(num, precision) {
  return parseFloat(parseFloat(num).toFixed(precision));
}

function parseDateOrToday(datValue) {
  return isNaN(Date.parse(datValue)) ? new Date() : new Date(datValue);
}

function listDaysFromDate(startDate = null, numDays = 7, businessOnly = false) {
  startDate = isNaN(Date.parse(startDate)) ? new Date() : new Date(startDate);
  let daysRemaining = Math.max(1, numDays);

  let dateArray = [];
  let iterations = 0;

  while (daysRemaining) {
    let curDate = new Date(startDate.valueOf());
    curDate.setDate(curDate.getDate() + iterations);
    iterations += 1;

    if (curDate.getDay() % 6 == 0 && businessOnly) {
      continue;
    }

    curDate = `${curDate.getFullYear()}-${curDate.getMonth() + 1}-${curDate.getDate()}`;
    dateArray.push(curDate);

    daysRemaining -= 1;
  }

  return dateArray;
}
